var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var IPCRules = require('../ipcRules');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IpcSmdPadGeneratorWithThermalPadData = require('./ipcSmdPadGeneratorWithThermalPadData.js');
var DualRowPackageData = require('./dualRowPackageData.js');

var DualRowPackageWithThermalPadData = function(position, angle, init) {
    IpcSmdPadGeneratorWithThermalPadData.apply(this, arguments);
};

lib_core.inherit(DualRowPackageWithThermalPadData, IpcSmdPadGeneratorWithThermalPadData);
lib_core.JsonParser.registerClass(DualRowPackageWithThermalPadData, "DualRowPackageWithThermalPadData");

module.exports = DualRowPackageWithThermalPadData;

DualRowPackageWithThermalPadData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = DualRowPackageData.prototype.getPads.call(this, absolutePositions);

    //add thermal pad
    if(self.hasThermalPad()) {
        pads.push(self.getThermalPad(self.thermalPadLength(), self.thermalPadWidth()));
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};

DualRowPackageWithThermalPadData.prototype.getSilkscreen = function(pads) {
    return DualRowPackageData.prototype.getSilkscreen.call(this, pads);
};

DualRowPackageWithThermalPadData.prototype.getTopAndDownSilkscreenWithSides = function(body, start, height, silkscreen) {
    //top with sides
    var pathData = new PathData(new lib_geometry.Coord(-body.width / 2, start), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, height), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, height), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, start), PathType.LINE));
    silkscreen.push(pathData);

    //down with sides
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);
};

DualRowPackageWithThermalPadData.prototype.getTopAndDownSilkscreenWithoutSides = function(body, start, silkscreen) {
    //top
    var pathData = new PathData(new lib_geometry.Coord(-body.width / 2, start + IPCRules.silkscreenStrokeWidth / 2), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, start + IPCRules.silkscreenStrokeWidth / 2), PathType.LINE));
    silkscreen.push(pathData);

    //down
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);
};

DualRowPackageWithThermalPadData.prototype.populateSilkscreenForBody = function(body, topPad, bottomPad, silkscreen) {
    var topEdge = topPad.getPos().y + topPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance;
    var thermalPadWithClearance;

    if(this.hasThermalPad()) {
        thermalPadWithClearance = this.thermalPadWidth() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2;
    }

    //if left first pad's top edge is above the top edge of body
    if (topEdge > body.height / 2) {
        //if thermal pad exists and thermal pad top edge with clearance is above left first pad's top edge draw silkscreen over thermal pad
        if(this.hasThermalPad() && thermalPadWithClearance >= topEdge) {
            this.getTopAndDownSilkscreenWithSides(body, topEdge, thermalPadWithClearance, silkscreen);
        } else {
            this.getTopAndDownSilkscreenWithoutSides(body, topEdge, silkscreen);
        }
    } else {
        //if thermal pad exists and thermal pad top edge with clearance is above left first pad's top edge draw silkscreen over thermal pad
        if(this.hasThermalPad() && thermalPadWithClearance >= topEdge) {
            //draw top and bottom silkscreen on body if there is at least a gap of silkscreen clearance between body top edge and thermal pad top
            if(body.height / 2 >= thermalPadWithClearance) {
                this.getTopAndDownSilkscreenWithSides(body, topEdge, body.height / 2, silkscreen);
            } else { //draw silkscreen around thermal pad at clearance distance from thermal pad top edge
                this.getTopAndDownSilkscreenWithSides(body, topEdge, thermalPadWithClearance, silkscreen);
            }
        } else {
            this.getTopAndDownSilkscreenWithSides(body, topEdge, body.height / 2, silkscreen);
        }
    }
};